module.exports = __webpack_public_path__ + "static/media/edMain03.b6405869.png";